import {
	ContentBox,
	SystemInfoLayout,
} from '@dealstack/frontend/shared/layout/SystemInfoLayout/SystemInfoLayout';
import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { useTranslationNotFound } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const Page404 = ({ className }: Props) => {
	const tNotFound = useTranslationNotFound();

	return (
		<SystemInfoLayout className={className}>
			<Page404Image src="/context/page404/404-image.svg" />
			<TitleText bold variant="h4">
				{tNotFound('title')}
			</TitleText>
			<InfoText colorFaded variant="p-lg">
				{tNotFound('message')}
			</InfoText>
			<Link to="/">
				<Button variant="primary">{tNotFound('button')}</Button>
			</Link>
		</SystemInfoLayout>
	);
};

const TitleText = styled(Text)``;
const InfoText = styled(Text)``;

const Page404Image = styled(AssetsLoader)`
	&.svg {
		width: fit-content;
		height: 12rem;
	}
`;

const Memoized = memo(Page404);
const Styled = styled(Memoized)`
	${Page404Image} {
		margin-bottom: 1.5rem;
	}

	${TitleText} {
		margin-bottom: 0.5rem;
	}

	${Button} {
		margin-top: 1.5rem;
	}

	${ContentBox} {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;

export { Styled as Page404 };
